import React from 'react';
import { connect } from 'react-redux';
import Carrousel from './Carrousel';
import Grid from './Grid';
import * as Maps from '../../store/map';

function Home(props) {
    return (
        <div className="main-container bg-f7">
            <Carrousel {...props} />
            <Grid {...props} />
        </div>
    );
}

export default connect(Maps.mapUserStateToProps, Maps.mapUserDispatchToProps)(Home);
